module.exports = __webpack_public_path__ + "static/img/recovery_password.aa6d44c9.png";